/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDiningTableDto } from '../../models/api-response-dining-table-dto';

export interface RegenerateDiningTableQr$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function regenerateDiningTableQr(http: HttpClient, rootUrl: string, params: RegenerateDiningTableQr$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDiningTableDto>> {
  const rb = new RequestBuilder(rootUrl, regenerateDiningTableQr.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDiningTableDto>;
    })
  );
}

regenerateDiningTableQr.PATH = '/v1/api/dining-tables/{reference}/regenerate-qr';
